import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
} from "@mui/material";
export const StackBarChart_AgentStatistic = ({ chatAgent, datalabels }) => {
  const theme = useTheme();
  const [data, setData] = useState(null);

  const options = {
    cornerRadius: 20,
    layout: { padding: 0 },
    maintainAspectRatio: false,
    responsive: true,
    xAxes: [
      {
        ticks: {
          fontColor: theme.palette.text.secondary,
        },
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          fontColor: theme.palette.text.secondary,
          beginAtZero: true,
          min: 0,
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: theme.palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: theme.palette.divider,
        },
      },
    ],
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: "index",
      titleFontColor: theme.palette.text.primary,
    },
    interaction: {
      mode: "index",
      intersect: false,
    },
    hover: {
      mode: "nearest",
      intersect: true,
    },
    plugins: {
      datalabels,
    },
  };

  useEffect(() => {
    const setLocalChatAgent = () => {
      setData({
        labels: chatAgent?.map((x) => x.AgentName),
        datasets: [
          {
            label: "Assigned",
            maxBarThickness: 40,
            data: chatAgent?.map((x) => x.AssignedCount),
            backgroundColor: "#0343C7",
            datalabels: {
              anchor: "center",
              align: "center",
            },
          },
          {
            label: "Close",
            maxBarThickness: 40,
            data: chatAgent?.map((x) => x.ClosedCount),
            backgroundColor: "#F97427",
            datalabels: {
              anchor: "center",
              align: "center",
            },
          },
        ],
      });
    };
    setLocalChatAgent();
  }, [chatAgent]);

  return (
    <div style={{ height: 380, paddingTop: 10, paddingBottom: 10 }}>
      {data ? <Bar id="AgentStatisticBar" data={data} options={options} /> : ""}
    </div>
  );
};

export default StackBarChart_AgentStatistic;
